import React from 'react';
import SignUpFlowContainer from './SignUpFlowContainer';
import { SignUpFlowProvider } from './SignUpFlowContext';

const SignUpFlow = () => {
  return (
    <SignUpFlowProvider>
      <SignUpFlowContainer />
    </SignUpFlowProvider>
  );
};

export default SignUpFlow;
